import { http } from "../../../components/services/httpService";

export async function fetchResumeData( id ) {
    const response = await http( `resumes/${ id }` );
    if ( !response.ok ) {
        console.error( "Failed to fetch resume data:", response.status );
        throw new Error( `Failed to fetch resume data: ${ response.status }` );
    }
    return await response.json();

}

export async function updateResumeData( resumeData ) {
    const options = {
        method: 'PUT',
        body: JSON.stringify( resumeData ),
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const response = await http( `resumes/${ resumeData.id }`, options );
    if ( !response.ok ) {
        console.error( 'Failed to update resume data:', response.status );
        throw new Error( `Failed to update resume data: ${ response.status }` );
    }
    return await response.json();
}

